import React from 'react';
import styled from 'styled-components';
import { Location } from '@reach/router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import '../../index.css';

const Container = styled.div`
  margin: 5px 0;

  @media (min-width: 767px) {
    margin: 5px;
  }

  .transition-group {
    height: 30px;
  }
`;

const Title = styled.div`
  font-family: 'Fjalla One', sans-serif;
  font-size: 32px;
  text-transform: uppercase;
`;

const SubTitle = styled.div`
  font-family: 'Lovers Quarrel', cursive;
  font-size: 30px;
`;

function Header() {
  return (
    <Container>
      <Title data-testid="title">Armando Torres</Title>
      <Location>
        {({ location }) => {
          return (
            <TransitionGroup className="transition-group">
              <CSSTransition key={location.key} classNames="fade" timeout={900}>
                <SubTitle data-testid="sub-title" className="subtitle">
                  {location.pathname === '/'
                    ? 'digital craftsmanship'
                    : 'artisanal, handcrafted development'}
                </SubTitle>
              </CSSTransition>
            </TransitionGroup>
          );
        }}
      </Location>
    </Container>
  );
}

export default Header;
